<div class="mb-6 rounded-xl border border-slate-200 bg-white p-5">
    <h4 class="mb-4 text-base font-semibold text-slate-800">
        {{ 'translate_filter_results' | translate }}
    </h4>

    <!-- Filter fields -->
    <div
        class="grid grid-cols-1 items-center gap-4 md:grid-cols-3 lg:grid-cols-4"
    >
        <ng-content></ng-content>
    </div>
</div>
